var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Header/index.tsx";
import React from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
const Header = ({
  title,
  subtitle,
  titleTestID,
  subtitleTestID,
  visible = true,
  textAlign,
  titleProps,
  ...rest
}) => {
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Stack, Object.assign({
    paddingHorizontal: "$4"
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Text, Object.assign({
    testID: titleTestID,
    textAlign: textAlign,
    fontSize: "$h1.strong",
    fontWeight: "$h1.strong",
    marginTop: "$4"
  }, titleProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 7
    }
  }), title), /*#__PURE__*/React.createElement(Text, {
    testID: subtitleTestID,
    textAlign: textAlign,
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    color: "$text.100",
    marginTop: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 7
    }
  }, subtitle));
};
export { Header };